// src/hooks/useNotificationsCount.js
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../store/authSlice";
import API from "../api";
import socket from "../socket"; // singleton socket

export default function useNotificationsCount() {
  const user = useSelector(selectUser);
  const ass = useMemo(() => (user?.ass ?? 2), [user]);  // default 2
  const [count, setCount] = useState(0);

  const fetchCount = async () => {
    try {
      const resp = await API.get("/notifications", { params: { ass } });
      const rows = Array.isArray(resp?.data) ? resp.data : [];
      setCount(rows.length);
    } catch (e) {
      // keep old count on failure
      // console.warn("notif count fetch failed", e?.response?.status, e?.message);
    }
  };

  useEffect(() => {
    fetchCount();                 // on mount / ass change
  }, [ass]);

  useEffect(() => {
    const id = setInterval(fetchCount, 20_000); // poll every 20s
    return () => clearInterval(id);
  }, [ass]);

  useEffect(() => {
    const refresh = () => fetchCount(); // live update on socket pushes
    socket.on("notifications:new", refresh);
    socket.on("notifications:removed", refresh);
    socket.on("notifications:cleared", refresh);
    return () => {
      socket.off("notifications:new", refresh);
      socket.off("notifications:removed", refresh);
      socket.off("notifications:cleared", refresh);
    };
  }, [ass]);

  return count;
}
